import { render, staticRenderFns } from "./SearchSuggestion.vue?vue&type=template&id=63335cef&scoped=true&"
import script from "./SearchSuggestion.vue?vue&type=script&lang=ts&"
export * from "./SearchSuggestion.vue?vue&type=script&lang=ts&"
import style0 from "./SearchSuggestion.vue?vue&type=style&index=0&id=63335cef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63335cef",
  null
  
)

export default component.exports